const DAY_MS = 24 * 60 * 60 * 1000;

export function normalizeRetentionDays(days) {
	const n = Number(days);
	if (!n || n <= 0 || !isFinite(n)) {
		return 0;
	}
	return n;
}

/** 会话保留天数只约束群聊，私聊/系统通知不清历史 */
export function resolveRetentionDays(chat, days) {
	if (!chat || chat.type != 'GROUP') {
		return 0;
	}
	return normalizeRetentionDays(days);
}

export function getChatRecordCutoff(days) {
	const n = normalizeRetentionDays(days);
	if (!n) {
		return 0;
	}
	return Date.now() - n * DAY_MS;
}

export function isRetainedChatMessage(msg, cutoff) {
	if (!msg) {
		return false;
	}
	if (!cutoff) {
		return true;
	}
	if (msg.loadStatus === 'loading' || msg.loadStatus === 'fail') {
		return true;
	}
	if (msg.selfSend && msg.tmpId && !msg.id) {
		return true;
	}
	const t = Number(msg.sendTime);
	if (!t) {
		return true;
	}
	return t >= cutoff;
}

export function filterMessagesByRetention(messages, days) {
	if (!Array.isArray(messages)) {
		return [];
	}
	const cutoff = getChatRecordCutoff(days);
	if (!cutoff || !messages.length) {
		return messages;
	}
	return messages.filter((m) => isRetainedChatMessage(m, cutoff));
}
